<template>
	<uploader
		:title="title"
		:subtitle="subtitle"
		:album-id="albumId"
		photo-category="individual_category"
		:stop-button="stopButton"
		:choose-file-component="chooseFileComponent"
		:project="project"
		:allow-file-uploads="false"
		choose-file-message="Select a folder with your subject data in a CSV and all of the images associated with it"
		:confirm-upload-component="confirmUploadComponent"
		choose-file-step-description="the Upload Folder button"
		confirm-upload-step-description="how to map subject fields"
		upload-progress-step-description="patiently while your subjects upload..."
		data-app
		ref="uploader"
		:create-import-event="createImportEvent"
		:finish-import-event="finishImportEvent"
		:project-import-id="projectImportId"
		@stop="stop"
		@all-uploads-finished="allUploadsFinished"
		:max-concurrent-uploads="maxConcurrentUploads"
		/>
</template>

<script>
import Uploader from './Uploader';
import ChooseSubjectFiles from './ChooseSubjectFiles';
import SubjectMapping from './SubjectMapping';
import { plicAxios, shouldRetryAll } from '../utils/axios';

export default {
	props: {
		project: null,
		stopButton: null,
		maxConcurrentUploads: {
			default: () => 5
		}
	},
	data() {
		let orgName = this.project.organizationName;
		if(this.project.organizationShortCode) {
			orgName += ' - ' + this.project.organizationShortCode;
		}

		let jobName = this.project.jobName;
		if(this.project.jobShortCode) {
			jobName += ' - ' + this.project.jobShortCode;
		}

		return {
			title: orgName,
			subtitle: 'Upload your subject images and data to ' + jobName,
			photoCategory: 'individual_category',
			chooseFileComponent: ChooseSubjectFiles,
			confirmUploadComponent: SubjectMapping,
			projectImportId: null,
			albumImportId: null
		};
	},
	computed: {
		albumId() {
			return this.project?.plicSubjectAlbumId ?? 'stub';
		}
	},
	methods: {
		stop() {
			this.$emit('stop');
		},
		createImportEvent() {
			return new Promise((resolve, reject) => {
				plicAxios.post(`projects/${this.project.plicProjectId}/project-imports.json`, null, {
					raxConfig: {
						shouldRetry: shouldRetryAll
					}
				}).then((response) => {
					this.projectImportId = response.data.project_import.id;
					return plicAxios.post('albums/' + this.project.plicSubjectAlbumId + '/album-imports.json', {
						project_import_id: this.projectImportId
					}, {
						raxConfig: {
							shouldRetry: shouldRetryAll
						}
					});
				}).then((response) => {
					this.albumImportId = response.data.album_import.id;
					resolve(this.albumImportId);
				}).catch((error) => {
					reject(error);
				});
			});
		},
		finishImportEvent() {
			return plicAxios.patch(`project-imports/${this.projectImportId}/finish.json`).then(() => {
				return plicAxios.patch(`album-imports/${this.albumImportId}/finish.json`);
			});
		},
		allUploadsFinished() {
			this.$emit('all-uploads-finished', this.$refs.uploader.uploads);

			let subjects = this.$refs.uploader.uploads.reduce((subjects, upload) => {
				if(!upload.subjects) {
					return subjects;
				}

				subjects.push(...upload.subjects);
				return subjects;
			}, []);
			this.$emit('all-subjects-finished', subjects);
		}
	},
	components: {
		Uploader
	}
};
</script>